import {
  ActionGroup,
  Alert,
  Button,
  Form,
  FormGroup,
  Grid,
  GridItem,
  Modal,
  ModalVariant,
  TextInput,
} from '@patternfly/react-core'
import * as React from 'react'
import { useCallback, useState } from 'react'

import type { IProgramInteraction } from '@app/domain/program/program.interface'

interface Props {
  isModalOpen: boolean
  onClose: () => void
  addReportTemplate: (
    programInteractionId: string,
    templateId: string,
    label?: string,
  ) => Promise<void>
  programInteraction?: IProgramInteraction
}

export const ManageReportTemplatesModal = function ({
  addReportTemplate,
  isModalOpen,
  onClose,
  programInteraction,
}: Props) {
  const onCloseAction = useCallback(() => {
    setTemplateId(undefined)
    setLabel(undefined)
    onClose()
  }, [onClose])

  const [templateId, setTemplateId] = useState<string | undefined>(undefined)
  const [label, setLabel] = useState<string | undefined>(undefined)

  const handleAddReportTemplate = useCallback(() => {
    addReportTemplate(programInteraction?.id, templateId, label).then(() => {
      setTemplateId(undefined)
      setLabel(undefined)
      onClose()
    })
  }, [addReportTemplate, label, onClose, programInteraction?.id, templateId])

  const onChangeTemplateId = useCallback((updatedTemplateId: string) => {
    setTemplateId(updatedTemplateId)
  }, [])

  const onChangeLabel = useCallback((updatedLabel: string) => {
    setLabel(updatedLabel)
  }, [])

  if (programInteraction) {
    return (
      <Modal
        variant={ModalVariant.small}
        title="Add Report Template"
        isOpen={isModalOpen}
        onClose={onCloseAction}
      >
        <>
          <Alert
            variant="info"
            title="The report template ID must match the template ID in the report generation service. If you are unsure what report template ID to use, please contact Cohesic Support."
          />
          <br />
        </>
        <Form autoComplete="off">
          <Grid hasGutter md={6}>
            <GridItem span={6}>
              <FormGroup
                label="Template ID"
                isRequired
                fieldId="templateId"
                helperTextInvalid="Template Id is required"
              >
                <TextInput
                  isRequired
                  value={templateId}
                  type="text"
                  id="templateId"
                  name="Template ID"
                  onChange={onChangeTemplateId}
                />
              </FormGroup>
            </GridItem>
            <GridItem span={6}>
              <FormGroup label="Label" fieldId="label">
                <TextInput
                  value={label}
                  type="text"
                  id="label"
                  name="Label"
                  onChange={onChangeLabel}
                />
              </FormGroup>
            </GridItem>
          </Grid>
        </Form>
        <ActionGroup style={{ float: 'right', marginTop: 10 }}>
          <Button
            key="cancel"
            variant="secondary"
            style={{ marginRight: 5 }}
            onClick={onCloseAction}
          >
            Cancel
          </Button>
          <Button
            key="confirm"
            variant="primary"
            onClick={handleAddReportTemplate}
            isDisabled={templateId === undefined}
          >
            Save
          </Button>
        </ActionGroup>
      </Modal>
    )
  }
  return <></>
}
